<template>
    <div id="app">
        <div v-if="hasInternet">
            <!--<transition  name="fade" mode="out-in"></transition>-->
                <router-view></router-view>
            
        </div>
        <div v-else>
            <div id="body_offline" align="center">
                <div id="box_offline" :style="{'background': this.$store.state.device.color+'repeat-x right top'}">
                    <br>
                    <h3 style="padding-bottom: 15px;">A versão offline ainda não está disponível.</h3>
                    <br>
                    <p id="p_offline">
                        Para aceder necessita de estar ligado na rede.
                        <br>
                        <br>
                        Obrigado!
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import NavbarTop from "./components/navbarTop";
    import navbarBottom from "./components/navbarBottom";
    export default {
        components: {NavbarTop, navbarBottom},
        data() {
            return {
                hasInternet: true
            };
        },
        mounted() {
            if(localStorage.getItem('language') !== 'pt' && localStorage.getItem('language') !== 'en') localStorage.setItem('language', 'pt');
            window.addEventListener("online", () => {
                this.hasInternet = true;
            });
            window.addEventListener("offline", () => {
                this.hasInternet = false;
            });
        }
    }
</script>

<style lang="scss">
    @import './main.css';

    #app {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        background-color: #ffffff;
    }

    //PAGINATION
    .pagination a {
        border-color: #2B2D42 !important;
    }
    .pagination-list {
        margin-bottom: 0;
    }
    .pagination-link.is-current {
        background-color: #2B2D42 !important;
        border-color: #2B2D42 !important;
    }

    //INPUT AND TEXTAREA BORDERS AND SHADOWS
    textarea:focus,
    input[type="text"]:focus,
    input[type="password"]:focus,
    input[type="datetime"]:focus,
    input[type="datetime-local"]:focus,
    input[type="date"]:focus,
    input[type="month"]:focus,
    input[type="time"]:focus,
    input[type="week"]:focus,
    input[type="number"]:focus,
    input[type="email"]:focus,
    input[type="url"]:focus,
    input[type="search"]:focus,
    input[type="tel"]:focus,
    input[type="color"]:focus,
    input[id="VuePhoneNumberInput_country_selector"]:focus,
    input[id="VuePhoneNumberInput_country_selector"]:active,
    input[id="VuePhoneNumberInput_country_selector"]:hover {
        border-color: #2B2D42 !important;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px #2B2D42 !important;
        outline: 0 none !important;
    }
    select:focus{
        border-color: #2B2D42 !important;
        outline:none !important;
        box-shadow: 0 0 2px #2B2D42 !important;
    }
    select{
        border-color: #2B2D42 !important;
        outline:none !important;
        box-shadow: 0 0 2px #2B2D42 !important;
    }

    //OFFLINE
    #body_offline {
        height: 100vh;
        color: #ffffff;
    }

    #p_offline {
        padding-top: 10%;
        margin-bottom: 0 !important;
        font-size: 20px;
    }

    #box_offline {
        height: 85vh;
        width: 100%;
        font-size: 26px;
        font-style: oblique;
        color: #FFF;
        text-align: center;
        margin-left: 5px;
        display: table-cell;
        vertical-align: middle;
    }

    //TOAST
    .toast .is-danger .is-bottom {
        margin-top: 100px;
    }
    .notices {
        z-index: 10000;
    }
    .notices.is-top {
        z-index: 10000;
    }
    .notices.is-bottom {
        z-index: 10000;
    }

    //ROUTER FADE TRANSITION
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.1s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }
</style>
